<template>
  <div class="batch-query-create">

    <el-form ref="createFormRef" :model="createForm" :rules="createRules" label-width="120px" class="create-form">
      <el-form-item label="任务名称" prop="taskName">
        <el-input v-model="createForm.taskName" placeholder="请输入任务名称" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      
      <el-form-item label="包含港澳台">
        <el-radio-group v-model="includeHmt" @change="handleHmtChange">
          <el-radio :value="false">不包含</el-radio>
          <el-radio :value="true">包含</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item label="快递公司">
        <div class="company-list" v-loading="companyLoading">
          <el-radio-group v-model="selectedCompanies">
            <el-radio v-for="company in companyList" :key="company.company.company_id" :value="company.company.company_id">
              {{ company.company.company_name }}
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      
      <el-form-item label="选择操作">
       <div class="address-controls">
          <el-button @click="handleAllCheck">全选</el-button>
          <el-button @click="handleUnselectAll">全不选</el-button>
          <el-button @click="handleReverseCheck">反选</el-button>
        </div>

      </el-form-item>
        
      <el-form-item label="地址选择">
        <div class="address-weight-container">
          <div class="address-list" v-loading="loading">
            <el-tree
              ref="addressTree"
              :data="treeData"
              show-checkbox
              node-key="id"
              :props="treeProps"
              :check-strictly="false"
              :default-expanded-keys="defaultExpandedKeys"
              @check-change="handleCheckChange"
              @check="handleCheck"
              class="address-tree"
            ></el-tree>
          </div>
          <div class="weight-volume-container">
            <el-form-item prop="weightVolume">
              <el-input
                type="textarea"
                v-model="createForm.weightVolume"
                placeholder="请输入重量与体积的组合，格式为重量*体积，用回车分隔不同的组合（如：10*0.5，2.5*1）"
                :rows="8"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
            
            <!-- 提交任务按钮 -->
            <div class="submit-button-container">
              <el-button type="primary" @click="submitCreateForm">提交任务</el-button>
              <!-- <el-button @click="resetCreateForm">重置</el-button> -->
            </div>
          </div>
        </div>
      </el-form-item>
      

      

    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { postWlApi } from '../utils/api_v1.js'

const createFormRef = ref(null)
const addressTree = ref(null)
const createForm = reactive({
  taskName: '',
  weightVolume: ''
})

const createRules = {
  taskName: [
    { required: true, message: '请输入任务名称', trigger: 'blur' },
    { min: 1, max: 50, message: '任务名称长度在 1 到 50 个字符', trigger: 'blur' }
  ],
  weightVolume: [
    { required: true, message: '请输入重量与体积的组合', trigger: 'blur' }
  ]
}

// 地址选择相关状态
const includeHmt = ref(false)
const loading = ref(false)
const addressList = ref([])
const selectedAddresses = reactive({})

// 快递公司相关状态
const companyList = ref([])
const selectedCompanies = ref(null)
const companyLoading = ref(false)

// 树状结构数据
const treeData = computed(() => {
  return addressList.value.map((province, provinceIndex) => ({
    id: `province-${provinceIndex}`,
    label: province.province,
    children: province.cities.map((city, cityIndex) => ({
      id: `city-${provinceIndex}-${cityIndex}`,
      label: city
    }))
  }))
})

// 树状结构配置
const treeProps = {
  label: 'label',
  children: 'children'
}

// 默认展开节点 - 设为空数组，所有节点默认折叠
const defaultExpandedKeys = computed(() => {
  return []
})

// 获取地址列表
const fetchAddressList = async () => {
  loading.value = true
  try {
    const response = await postWlApi('/province_city/', {
      include_hmt: includeHmt.value
    })
    
    if (response.code === 0) {
      const provinces = response.data.provinces
      addressList.value = provinces
      
      // 初始化选中地址对象
      provinces.forEach(province => {
        selectedAddresses[province.province] = []
      })
    } else {
      ElMessage.error('获取地址列表失败')
    }
  } catch (error) {
    console.error('获取地址列表出错:', error)
    ElMessage.error('获取地址列表失败')
  } finally {
    loading.value = false
  }
}

// 切换包含港澳台
const handleHmtChange = () => {
  fetchAddressList()
}

// 处理树节点勾选变化
const handleCheckChange = (data, checked, indeterminate) => {
  // 当节点状态变化时，更新selectedAddresses
  if (data.children) {
    // 省份节点
    const provinceName = data.label
    selectedAddresses[provinceName] = checked ? data.children.map(child => child.label) : []
  } else {
    // 城市节点
    const provinceNode = treeData.value.find(prov => 
      prov.children.some(child => child.id === data.id)
    )
    if (provinceNode) {
      const provinceName = provinceNode.label
      const cityName = data.label
      
      if (!selectedAddresses[provinceName]) {
        selectedAddresses[provinceName] = []
      }
      
      const index = selectedAddresses[provinceName].indexOf(cityName)
      if (checked && index === -1) {
        selectedAddresses[provinceName].push(cityName)
      } else if (!checked && index !== -1) {
        selectedAddresses[provinceName].splice(index, 1)
      }
    }
  }
}

// 处理树节点勾选事件
const handleCheck = (data, checkedInfo) => {
  // 这里可以处理更复杂的勾选逻辑，如果需要的话
}

// 处理全选
const handleAllCheck = () => {
  if (!addressTree.value) return
  // 获取所有节点的key
  const allKeys = []
  const getAllKeys = (nodes) => {
    nodes.forEach(node => {
      allKeys.push(node.id)
      if (node.children && node.children.length > 0) {
        getAllKeys(node.children)
      }
    })
  }
  getAllKeys(treeData.value)
  // 选中所有节点
  addressTree.value.setCheckedKeys(allKeys)
  
  // 更新selectedAddresses
  addressList.value.forEach(province => {
    selectedAddresses[province.province] = [...province.cities]
  })
}

// 处理全不选
const handleUnselectAll = () => {
  if (!addressTree.value) return
  // 取消选中所有节点
  addressTree.value.setCheckedKeys([])
  
  // 更新selectedAddresses
  addressList.value.forEach(province => {
    selectedAddresses[province.province] = []
  })
}

// 处理反选
const handleReverseCheck = () => {
  if (!addressTree.value) return
  // 获取所有节点的key
  const allKeys = []
  const getAllKeys = (nodes) => {
    nodes.forEach(node => {
      allKeys.push(node.id)
      if (node.children && node.children.length > 0) {
        getAllKeys(node.children)
      }
    })
  }
  getAllKeys(treeData.value)
  
  // 获取当前选中的节点key
  const checkedKeys = addressTree.value.getCheckedKeys()
  
  // 计算反选后的节点key
  const reversedKeys = allKeys.filter(key => !checkedKeys.includes(key))
  
  // 设置反选后的节点
  addressTree.value.setCheckedKeys(reversedKeys)
  
  // 更新selectedAddresses
  addressList.value.forEach(province => {
    const provinceNode = treeData.value.find(prov => prov.label === province.province)
    if (provinceNode) {
      const selectedCities = []
      provinceNode.children.forEach(cityNode => {
        if (reversedKeys.includes(cityNode.id)) {
          selectedCities.push(cityNode.label)
        }
      })
      selectedAddresses[province.province] = selectedCities
    }
  })
}

// 提交任务
const submitCreateForm = async () => {
  if (!createFormRef.value) return
  
  try {
    await createFormRef.value.validate()
    
    // 收集选中的地址
    const selectedProvinces = addressList.value.filter(province => {
      return selectedAddresses[province.province]?.length > 0
    })
    
    if (selectedProvinces.length === 0) {
      ElMessage.error('请至少选择一个地址')
      return
    }
    
    if (selectedCompanies.value === null) {
      ElMessage.error('请选择一个快递公司')
      return
    }
    
    const selectedData = selectedProvinces.map(province => ({
      province: province.province,
      cities: selectedAddresses[province.province]
    }))
    
    // 处理重量与体积组合数据
    let queryParams = []
    if (createForm.weightVolume) {
      // 按换行符分割，过滤空行
      const combinations = createForm.weightVolume
        .split('\n')
        .map(line => line.trim())
        .filter(line => line.length > 0)
      
      // 定义正则表达式验证格式：数字kg*数字m³
      const weightVolumeRegex = /^(\d+(\.\d+)?)\*(\d+(\.\d+)?)$/i
      
      // 验证并转换数据
      for (let i = 0; i < combinations.length; i++) {
        const line = combinations[i]
        const match = line.match(weightVolumeRegex)
        
        if (!match) {
          ElMessage.error(`第${i + 1}行格式错误，正确格式应为：重量*体积（如：10*0.5，2.5*1）`)
          return
        }
        
        // 提取重量和体积值
        const weight = parseFloat(match[1])
        const volume = parseFloat(match[3])
        
        // 添加到结果数组
        queryParams.push({ weight, volume })
      }
    }
    
    // 调用API提交批量查询任务
    try {
      const response = await postWlApi('/batch_task/create/', {
        taskName: createForm.taskName,
        selectedAddresses: selectedData,
        selectedCompany: selectedCompanies.value,
        query_params: queryParams
      })
      
      if (response.code === 0) {
        ElMessage.success('批量查询任务提交成功')
      } else {
        ElMessage.error(`任务提交失败：${response.message}`)
      }
    } catch (error) {
      console.error('提交任务出错:', error)
      ElMessage.error('任务提交失败，请重试')
    }
    
    // 重置表单
    resetCreateForm()
  } catch (error) {
    console.error('表单验证失败:', error)
  }
}
// 重置表单
const resetCreateForm = () => {
  if (createFormRef.value) {
    createFormRef.value.resetFields()
  }
  
  // 重置重量体积输入
  createForm.weightVolume = ''
  
  // 重置地址选择
  addressList.value.forEach(province => {
    selectedAddresses[province.province] = []
  })
  
  // 通过el-tree API重置选中状态
  if (addressTree.value) {
    addressTree.value.setCheckedKeys([])
  }
  
  // 重置快递公司选择
  selectedCompanies.value = null
}

// 获取快递公司列表
const fetchCompanyList = async () => {
  companyLoading.value = true
  try {
    const response = await postWlApi('/company_access/', {})
    
    if (response.code === 0) {
      companyList.value = response.data.company_access
    } else {
      ElMessage.error('获取快递公司列表失败')
    }
  } catch (error) {
    console.error('获取快递公司列表出错:', error)
    ElMessage.error('获取快递公司列表失败')
  } finally {
    companyLoading.value = false
  }
}

// 页面加载时获取地址列表和快递公司列表
onMounted(() => {
  fetchAddressList()
  fetchCompanyList()
})
</script>

<style scoped>
.batch-query-create {
  padding: 20px 0;
  overflow-y: auto;
  max-height: 80vh;
}

.component-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.create-form {
  max-width: 680px;
}

.address-controls {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.address-list {
  margin-top: 15px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
}

.address-tree {
  margin-top: 10px;
}

.el-tree-node__content {
  height: 32px;
  align-items: center;
}

.el-tree--checkbox .el-tree-node__content {
  padding-left: 10px;
}

.submit-button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 20px;
}

.address-weight-container {
  display: flex;
  gap: 20px;
  align-items: stretch;
}

.address-list {
  flex: 1;
  margin-top: 0;
}

.weight-volume-container {
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
}

.company-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.company-list .el-radio {
  margin-right: 20px;
  margin-bottom: 10px;
}

</style>
